import React from 'react'
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import { useOrderStore } from 'src/hooks/order';

const OrderDetailViewInvoicesPopup = (props) => {
  const { SetStatus, data } = props;
  const [{ }, { }, { order_download_invoice }] = useOrderStore();
  const { translation: t } = System;

  const downloadInvoice = async (invoiceNumber) => {
    if (System.getCurrentRegionWithType(Constants.speedBoats.japanAbbr)) {
      System.popup('OrderJapanInvoicePopup', {
        orderNumber: data?.orderNumber,
        invoiceNumber: invoiceNumber
      })
    } else {
      await order_download_invoice(invoiceNumber)
    }
  }

  return (
    <>
      <div className="avnet-modal modal-600">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading pl-5">{t('viewAllInvoices')}</h3>
          </div>
          {/* Modal body */}
          <div className="modal-body py-0">
            <div className="clearfix" />

            <div className='mb-4 text-center'>
              <div className='mb-1 text-black font-13 font-arial'>{t('hereInvoicesForPONumber')} {data.poNumber}</div>
              <a href={void (0)} onClick={() => downloadInvoice(data.invoiceData)} className='text-blue font-arial'>({t('downloadAllInvoices')})</a>
            </div>

            <div className='mb-5 mx-5 px-3'>
              <div className="bs5 row text-center">
                {
                  data.invoiceData && data.invoiceData.length > 0 &&
                  data.invoiceData?.filter((item, index, self) => self.indexOf(item) === index && item !== null)?.map((v, i) => (
                    <div className='col-4 mb-1' key={i}
                      onClick={() => downloadInvoice([v])}><a href={void (0)}>
                        <i className='fa fa-download me-2 text-black'></i><span className='text-blue'>{v}</span></a></div>
                  ))
                }
              </div>

            </div>
          </div>
          {/* Modal footer */}
          <div className="modal-footer justify-content-center">
            <div className="modal-footer-actions">
              <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={(() => SetStatus(false))}>
                {t('close')}
              </button>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default OrderDetailViewInvoicesPopup